import React from 'react';
import clsx from 'clsx';

import { Divider as WtbDivider } from 'wtb-components';
import styles from './Divider.module.css';

const Divider = (props) => {
  const {
    className,
    size = 'big',
    ...other
  } = props;

  return (
    <WtbDivider
      className={clsx(styles.root, {
        [styles.big]: size === 'big',
        [styles.mid]: size === 'mid',
        [styles.small]: size === 'small'
      }, className)}
      {...other}
    />
  );
};

export default Divider;
